<template>
<div class="tobeSentCommission bgc">
    <!--<div class="filters">-->
    <!--</div>-->
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="subject" label="活动名称" min-width="250px" class-name="title">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img class="img" v-lazy="scope.row.coveratturlid" :alt="scope.row.eventname"
                             preview="tobeSentCommission">
                        <span>{{scope.row.eventname}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="datetime" label="活动起止时间" class-name="center" min-width="150px">
                <template slot-scope="scope">
                    <div>起：{{scope.row.begintime}}</div>
                    <div>止：{{scope.row.endtime}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="paybrokerage" label="待发放佣金（元）" class-name="center" min-width="120px">
                <template slot-scope="scope">￥{{scope.row.paybrokerage}}</template>
            </el-table-column>
            <el-table-column label="操作" width="180px" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                    <span class="separator-btn">
                        <el-button @click="handleView(scope.row)" type="text" size="small">详情</el-button>
                    </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                       :page-size="page.pageSize"
                       :pager-count="11" layout="prev, pager, next" :total="total">
        </el-pagination>
    </div>
</div>
</template>

<script>
import {getEventListByBrandBrokeragePay} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'tobeSentCommission',
    data() {
        return {
            param: {
                hostroletype: ''
            },
            page: {
                page: 1,
                pageSize: 10
            },
            tableData: [],
            total: 0
        }
    },
    mounted() {
        this._getList()
        if (!this.isRefresh) {
            this._getList()
        }
    },
    activated() {
        if (this.isRefresh) {
            if (this.isRefresh === 2) {
                this.param = {
                    hostroletype: ''
                }
                this.page.page = 1
            }
            this._getList()
            this.setIsRefresh(0)
        }
    },
    methods: {
        handleView(row) {
            this.$router.push({name: 'BBTobeSentCommissionView', query: {eventid: row.eventid}})
        },
        _getList() {
            this.setLoading(true)
            getEventListByBrandBrokeragePay({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.eventlist
                    this.total = data.data.pageinfo.rowcount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading', 'setIsRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['isRefresh'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.tobeSentCommission {
    padding: 20px;
    .imageText{
        display: flex;
        .img{
            width: 106px;
            height: 60px;
            margin-right: 10px;
        }
    }
}
</style>
